import React, { Fragment, useState, useEffect } from "react";
import { DotsVerticalIcon, PlusIcon } from "@heroicons/react/solid";
import { MenuIcon, XIcon } from "@heroicons/react/outline"; // Added
import { Menu, Transition } from "@headlessui/react";
import ReactTooltip from "react-tooltip";
import backendService from "../services.js/backendService";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function TopHeader({ getCreateButtonState, isMobileMenuOpen, setIsMobileMenuOpen }) {
  const [profilePicture, setProfilePicture] = useState(
    backendService.getLoggedInUser()["profilePicture"]
  );
  const [profilePictureLoaded, setProfilePictureLoaded] = useState(false);
  useEffect(async () => {
    setProfilePicture(backendService.getLoggedInUser()["profilePicture"]);
    setProfilePictureLoaded(true);
  }, [profilePictureLoaded]);
  return (
    <div className="top-header w-full">
      <div className="flex bg-background">
        <div className="flex justify-between items-center w-full h-[60px] px-4 md:px-5">
          {/* Hamburger Menu Button - Mobile Only */}
          {setIsMobileMenuOpen && ( // Check if prop is passed
            <div className="sm:hidden mr-3"> {/* Adjust margin as needed */}
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="p-1 rounded-md text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
              >
                {isMobileMenuOpen ? (
                  <XIcon className="h-6 w-6" aria-hidden="true" />
                ) : (
                  <MenuIcon className="h-6 w-6" aria-hidden="true" />
                )}
              </button>
            </div>
          )}
          <h3 className="text-primary text-xl md:text-2xl font-robo flex-grow min-w-0 whitespace-nowrap overflow-hidden text-ellipsis">Inbox</h3> {/* Added flex-grow */}
          <div
            className="flex items-center"
            data-tip="Start Conversation"
            data-place="bottom"
          >
            <div
              className="h-7 w-7 flex items-center justify-center text-palette_color1 hover:bg-palette_color1 hover:text-palette_color2 hover:rounded-full"
              onClick={(e) => {
                getCreateButtonState(e); // Changed from props.getCreateButtonState
              }}
            >
              <PlusIcon
                className="h-5 w-5 cursor-pointer"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopHeader;
